import React, { useMemo, useState, useRef } from 'react';
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
} from '@tanstack/react-table';
import { FixedSizeList as List } from 'react-window';

const VirtualizedTable = ({ data, columns, setChangePointMarker }) => {
  const ROW_HEIGHT = 35;
  const HEADER_HEIGHT = 32;
  const listRef = useRef(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const safeData = useMemo(() => data ?? [], [data]);
  const safeColumns = useMemo(() => columns ?? [], [columns]);

  const table = useReactTable({
    data: safeData,
    columns: safeColumns,
    initialState: {
      columnVisibility: {
        id: false,
        latitude: false,
        longitude: false,
        totalOdometer: false,
        ignition: false, 
        movement: false,
        batteryVoltage: false
      },
    },
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  const rows = table.getRowModel().rows ?? [];
  const visibleHeaders = table
    .getFlatHeaders()
    .filter((header) => header.column.getIsVisible());

  const Row = ({ index, style }) => {
    const row = rows[index];
    if (!row) return null;
    const isSelected = selectedRowIndex === index;

    return (
      <div
        style={{
          ...style,
          display: 'flex',
          width: '100%',
          backgroundColor: isSelected ? '#68d171ff' : 'white',
        }}
        className="border-b hover:bg-gray-100 cursor-pointer"
        onClick={() => {
          setSelectedRowIndex(index);
          setChangePointMarker?.({
            latitude: row.original.latitude,
            longitude: row.original.longitude,
            name: row.original.name,
            speed: row.original.speed,
            satelliteCount: row.original.satelliteCount,
          });
        }}
      >
        {row.getVisibleCells().map((cell) => (
          <div
            key={cell.id}
            className="flex items-center justify-center p-2 text-xs truncate flex-1 min-w-[71px] max-w-[71px]"
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div
      className="border rounded bg-white "
      style={{ maxHeight: 250 }}
    >
      {/* Encabezado */}
      <div
        className="flex border-b bg-gray-50 font-semibold z-20"
        style={{
          width: '100%',
          height: HEADER_HEIGHT,
          boxShadow: '0px 2px 4px rgba(0,0,0,0.05)',
        }}
      >
        {visibleHeaders.map((header) => (
          <div
            key={header.id}
            className="flex items-center justify-center p-1 text-xs truncate select-none flex-1 min-w-[71px] max-w-[71px]"
            
            onClick={header.column.getToggleSortingHandler()}
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
          </div>
        ))}
      </div>

      {/* Cuerpo virtualizado */}
      <div style={{ height: 200, width: '100%' }}>
        <List
          ref={listRef}
          height={200}
          itemCount={rows.length}
          itemSize={ROW_HEIGHT}
          width="100%"
          style={{
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          {Row}
        </List>
      </div>
    </div>
  );
};

export default VirtualizedTable;
